module.exports = __webpack_public_path__ + "img/bullet_1129.96d0880d.svg";